export default __webpack_public_path__ + "static/media/RB_5Gal.81680937.jpg";